<template>
    <img class="eye-button" :src="eyeSrc" @click="toggle">
</template>

<script>
    export default {
        name: 'PasswordEye',

        model: {
            prop: 'state',
            event: 'toggle'
        },

        props: {
            state: {
                type: Boolean,
                required: true
            }
        },

        computed: {
            eyeSrc() {
                return require(`images/formIcons/eye${this.state ? '' : '-slash'}.svg`);
            }
        },

        methods: {
            toggle() {
                this.$emit('toggle', !this.state);
            }
        }
    };
</script>

<style scoped>
    .eye-button {
        background-color: transparent !important;
        border: none !important;
        box-shadow: none !important;
        padding: 0 12px 0 0;
        height: 100% !important;
        width: 100% !important;
    }
</style>